import { createRouter, createWebHistory } from 'vue-router';

import pubs_beranda from '../views/modules/main/beranda-index.vue';
import Error404 from '../views/layouts/Error404.vue'
import Error500 from '../views/layouts/Error500.vue'
import store from '@/store';

const routes = [
    {
        path: '/',
        name: 'beranda',
        component: pubs_beranda
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'error-404',
        component: Error404
    },
    {
        path: '/error-500',
        name: 'error-500',
        component: Error500
    },
]

export const router = createRouter({
    history: createWebHistory('/'),
    linkActiveClass: 'active',
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { top: 0 }
    }
});

router.beforeEach((to, from, next) => {
    try {
        if (to.meta && to.meta.Title) {
            document.title = to.meta.Title;
        } else {
            document.title = 'BHGK Collaboration';
        }
        const userRaw = sessionStorage.getItem('USER')
        const user = userRaw ? JSON.parse(userRaw) : null
        const profileRaw = localStorage.getItem('users-info')
        const profile = profileRaw ? JSON.parse(profileRaw) : null

        const token = sessionStorage.getItem('TOKEN') ?? null

        localStorage.setItem('auth_token', token)

        const creds = {
            user: user,
            token: token,
        }

        store.commit('homePage/SET_USER', creds)
        store.commit('profile/SET_PROFILE', profile)
        next();
    } catch (error) {
        next({ name: 'error-500' });
    }
});

